/**
 * Ref-counted global API activity for a full-app loading overlay.
 * Used by apiFetch and other network entry points outside AgentContext.
 */

let count = 0;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export function beginGlobalApiLoading(): void {
  count += 1;
  emit();
}

export function endGlobalApiLoading(): void {
  count = Math.max(0, count - 1);
  emit();
}

export function getGlobalApiLoadingCount(): number {
  return count;
}

export function subscribeGlobalApiLoading(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
}
